import { Backdrop, Card, CardContent, CircularProgress, Divider, Grid, makeStyles, Paper, Typography } from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react';
import { palette, useStylesGlobal } from 'configurations/styles/theme';
import Plan from './components/Plan';
import { clientPay } from 'configurations/axios';
import { getRUCEmpresa } from 'redux/actions/userActions';
import { useSelector } from 'react-redux';
import useTitle from 'hooks/useTitle';

const useStyles = makeStyles((theme) => ({
    containerTitle: {
        paddingTop: "30px",
        flexGrow: 1,
        paddingLeft: "3%",
        paddingRight: "3%",
        marginBottom: "5%",
    },
    root2: {
        borderStyle: "solid",
        borderWidth: '2px',
        border: '#4583c7',
    },
    root3: {
        minWidth: 275,
        borderBlockColor: '#FFDD00',
    },
    title: {
        fontSize: 16,
        textAlign: 'center',
        marginBottom: 12,
    },
    subTitle: {
        marginTop: 12,
        fontSize: 14,
        textAlign: 'center',
    },
    subTitleBanco: {
        marginTop: '8px',
        fontSize: 14,
        textAlign: 'center',
        marginBottom: '8px',
    },
    backdrop: {
        zIndex: theme.zIndex.modal,
        color: palette.primary.main,
    },
    moduleHeader: {
        padding: "14px 16px",
        marginTop: 16,
        marginBottom: 10,
        borderLeft: `6px solid ${palette.primary.main}`,
    },
    moduleTitle: {
        fontSize: 18,
        fontWeight: 700,
    },
    moduleDesc: {
        fontSize: 13,
        opacity: 0.8,
        marginTop: 4,
    },
}));

const normalizeModuleName = (value) => {
    if (!value) return "Módulo";
    return String(value).replace(/_/g, " ").trim();
};

const BuyPackage = () => {
    const classes = useStyles();
    const classesGlobales = useStylesGlobal();
    const [plans, setPlanes] = useState([]);
    const [accounts, setAccounts] = useState([]);
    const userToken = useSelector((state) => state.user.tk);
    const [openLoader, setOpenLoader] = useState(false);

    const getPlans = async () => {
        try {
            const response = await clientPay.get(`/pago/paquetes/todos`);
            if (response.status === 200) setPlanes(response.data || []);
        } catch (exception) {
            console.log({ exception });
        }
    };

    const getAccounts = async () => {
        try {
            const ruc = userToken ? getRUCEmpresa(userToken) : '0';
            const response = await clientPay.get(`/pago/cuentas/${ruc}`);
            if (response.status === 200) setAccounts(response.data || []);
        } catch (exception) {
            console.log({ exception });
        } finally {
            setOpenLoader(false);
        }
    };

    useEffect(() => {
        getPlans();
        getAccounts();
    }, [])

    useTitle({ title: "Adquirir Plan" });

    //Agrupa los planes por módulo, conservando el orden que envía el backend dentro de cada módulo
    const plansByModule = useMemo(() => {
        const map = new Map();

        (plans || []).forEach((p) => {
            const idModulo = p?.modulo?.idModulo ?? "SIN_MODULO";
            if (!map.has(idModulo)) {
                map.set(idModulo, {
                    idModulo,
                    nombre: p?.modulo?.nombre,
                    descripcion: p?.modulo?.descripcion,
                    items: [],
                });
            }
            map.get(idModulo).items.push(p);
        });

        return Array.from(map.values()).sort((a, b) => {
            const aa = typeof a.idModulo === "number" ? a.idModulo : 999999;
            const bb = typeof b.idModulo === "number" ? b.idModulo : 999999;
            return aa - bb;
        });
    }, [plans]);

    return (
        <div className={classes.containerTitle}>
            <Paper className={classesGlobales.paperHeader}>
                <h5 className={classesGlobales.titleHeader}>Adquirir Plan</h5>
            </Paper>

            <Grid container direction="row" alignItems="center" justify="center" spacing={1}>

                {plansByModule.map((group) => (
                    <React.Fragment key={group.idModulo}>
                        <Grid item xs={12}>
                            <Paper className={classes.moduleHeader}>
                                <Typography className={classes.moduleTitle}>
                                    {normalizeModuleName(group.nombre || group.descripcion)}
                                </Typography>
                                <Typography className={classes.moduleDesc}>
                                    {group.descripcion}
                                </Typography>
                            </Paper>
                        </Grid>
                        {group.items.map((plan) => (
                            <Plan
                                key={plan.idPaquete}
                                plan={plan}
                                size={group.items.length}
                                idModulo={typeof group.idModulo === "number" ? group.idModulo : null}
                            />
                        ))}
                    </React.Fragment>
                ))}

                <Grid item xs={12} md={12}>
                    <Paper className={classes.root2}>
                        <Card>
                            <Typography className={classes.subTitleBanco} gutterBottom>
                                <strong>Pagos mediante transferencia o depósito Bancario</strong>
                            </Typography>
                        </Card>
                    </Paper>
                </Grid>

                {accounts.map((account, idx) => (
                    <Grid item xs={12} md={6} key={account?.idCuenta || `${account?.numeroCuenta || "cta"}-${idx}`}>
                        <Paper className={classes.moduleHeader}>
                            <Card className={classes.root3}>
                                <CardContent>
                                    <Typography className={classes.title} color='textSecondary' gutterBottom>
                                        <strong>{account.nombreBanco}</strong>
                                    </Typography>
                                    <Divider />
                                    <Typography className={classes.subTitle}>
                                        <strong>Razón Social: </strong> {account.razonSocial}
                                    </Typography>
                                    <Typography className={classes.subTitle}>
                                        <strong>RUC: </strong> {account.identificacion}
                                    </Typography>
                                    <Typography className={classes.subTitle}>
                                        <strong>Tipo de Cuenta: </strong>{account.tipoCuenta}
                                    </Typography>
                                    <Typography className={classes.subTitle}>
                                        <strong>Número de Cuenta: </strong>{account.numeroCuenta}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Paper>
                    </Grid>
                ))}

            </Grid>
            <Backdrop className={classes.backdrop} open={openLoader}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    )
}

export default BuyPackage;
